module.exports = __webpack_public_path__ + "static/media/pasadena_college_logo.ee9c743d.png";